import { render } from "./VIPReservation.vue?vue&type=template&id=14ac1832"
import script from "./VIPReservation.vue?vue&type=script&lang=js"
export * from "./VIPReservation.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Transcend INNCOM/INNCOM Project/2103.musoon.mobile.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__